// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"4c7e9174","571":"412ea93b","626":"dc379095","698":"a0e7d2dd","774":"8304b12f"}[chunkId] + ".chunk.js";
};